<template>
  <div>
    <common-header title="Assets">
      <template #btn>
        <el-col style="width: 65px">
          <el-button
            class="btn btn-default btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="showDialog({ type: CONSTANT.DIALOG_TYPE.ASSET })"
          >
            <i class="fas fa-file-upload"></i>
          </el-button>
        </el-col>
      </template>
    </common-header>
    <el-table-with-pagination
      :data="
        assets.filter(
          (data) =>
            !search || data.name.toLowerCase().includes(search.toLowerCase())
        )
      "
      row-key="_id"
      :page-sizes="[10, 15, 20]"
      @row-contextmenu="rowContextMenu"
      @row-dblclick="rowDblclick"
      @sort-change="sortChange"
      style="font-size: 18px"
      empty-text="No asset! Let's create a new asset!"
      border
    >
      <el-table-column prop="url" label="Preview">
        <template slot-scope="{ row }">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              height: 150px;
            "
          >
            <el-button
              class="btn btn-form btn-pink btn-footer"
              @click="preview(row)"
              v-if="row.mime_type.includes('zip')"
              >html preview</el-button
            >
            <img
              :src="row.url"
              v-if="row.mime_type.includes('image')"
              style="
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              "
            />
            <video
              playsinline
              :src="`${row.url}#t=0.1`"
              v-if="row.mime_type.includes('video')"
              style="
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              "
            ></video>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        :sort-orders="['ascending', 'descending']"
        min-width="300"
        sortable
      ></el-table-column>
      <el-table-column
        prop="mime_type"
        label="Type"
        :sort-orders="['ascending', 'descending']"
        sortable
      ></el-table-column>
      <el-table-column label="File"
        ><template slot-scope="{ row }">
          <span :class="{ pink: row.ffmpeg_url }">{{
            row.ffmpeg_url ? "compressed" : "original"
          }}</span></template
        ></el-table-column
      >
      <el-table-column align="right" width="250">
        <template slot="header" slot-scope="{ row }">
          <el-input v-model="search" placeholder="search" />
        </template>
        <template slot-scope="{ row }">
          <el-button
            class="btn btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="showDialog({ type: CONSTANT.DIALOG_TYPE.ASSET, row })"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Edit"
              placement="bottom"
            >
              <i class="fas fa-pen"></i>
            </el-tooltip>
          </el-button>
          <el-button
            class="btn btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.DELETE,
                row: {
                  item: CONSTANT.DIALOG_TYPE.ASSET,
                  id: row._id,
                  name: row.name,
                },
              })
            "
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Delete"
              placement="bottom"
            >
              <i class="fas fa-trash-alt"></i>
            </el-tooltip>
          </el-button>
        </template>
      </el-table-column>
    </el-table-with-pagination>
    <dialogs></dialogs>
    <context-menus></context-menus>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import CommonHeader from "@/components/base/header";
import ElTableWithPagination from "@/components/base/elTableWithPagination";
import Dialogs from "@/components/common/dialogs/index";
import ContextMenus from "@/components/common/contextMenus/index";
import MixFunc from "@/components/mixins/base";
export default {
  data() {
    return {
      search: "",
    };
  },
  components: {
    CommonHeader,
    ElTableWithPagination,
    Dialogs,
    ContextMenus,
  },
  mixins: [MixFunc],
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    assets: {
      get() {
        return this.$store.state.asset.assets;
      },
      set(value) {
        this.setAssets(value);
      },
    },
  },
  async created() {
    if (!this.assets.length) {
      await store.dispatch("asset/getAssets");
    }
  },
  methods: {
    ...mapMutations({
      setAssets: "asset/setAssets",
    }),
    ...mapActions({
      showContextMenu: "showContextMenu",
      showDialog: "showDialog",
    }),
    sortChange(val) {
      this.assets = _.orderBy(this.assets, (o) => o[val.prop], [
        val.order === "ascending" ? "asc" : "desc",
      ]);
    },
    rowContextMenu(row, col) {
      if (col.label) {
        this.showContextMenu({ type: CONSTANT.MENU_TYPE.ASSET, row });
      }
    },
    rowDblclick(row) {
      this.showDialog({ type: CONSTANT.DIALOG_TYPE.ASSET, row });
    },
    preview(row) {
      window.open(row.url, "_blank");
    },
  },
};
</script>

<style></style>
